import DropdownTemplateView from "../../DropdownTemplateView";
import BlockedListItem from "./BlockedListItem";
import MoreElementsBlockedListItem from "./MoreElementsBlockedListItem";

export default class BlockedList extends DropdownTemplateView {
    constructor($containerEl, entities) {
        super($containerEl);
        this.entities = entities;
    }

    templateHtml() {
        return "<div class='pointerWrapper'>" +
               "  <div class='deleteConfirmationDialogBlockedListScrollWrapper'>" +
               "    <div class='deleteConfirmationDialogBlockedList'></div>" +
               "  </div>" +
               "</div>";
    }

    afterRender()
    {
        this.$itemsContainer = this.find(".deleteConfirmationDialogBlockedList");
        _.each(this.entities, function(entity)
        {
            new BlockedListItem(this.$itemsContainer, this.getEntitySubtitle(entity), this.getEntityTitle(entity)).init();
        }, this);

        _.each(this.additionListItems(), function(entity)
        {
            new MoreElementsBlockedListItem(this.$itemsContainer, entity.title).init();
        }, this);

        this.verticalScroll = ScrollUtils.addVerticalScroll(this.find(".deleteConfirmationDialogBlockedListScrollWrapper"), {isFaded: false});
    }

    setDisabled(disabled)
    {
        this.disabled = disabled;
    }

    isDisabled() {
        return this.disabled;
    }

    onShow()
    {
        super.onShow();
        ScrollUtils.refreshCustomScroll(this.verticalScroll);
    }

    additionListItems()
    {
        return [];
    }

    getEntitySubtitle(entity)
    {
        // Abstract
    }

    getEntityTitle(entity)
    {
        // Abstract
    }
}


// WEBPACK FOOTER //
// ./web/js/cptManagement/deleteConfirmationDialog/BlockedList.js